import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken';

export async function publishDraft(draftId, html) {
  const token = await retrieveAccessToken();
  const response = await axios.post(`/api/editor/draft/publish/${encodeURIComponent(draftId)}`, html, {
    headers: { 'Content-Type': 'text/html', ...(token ? { Authorization: `Bearer ${token}` } : {}) }
  });
  return response.data;
}
